// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3Tthx","messages":"Chat_messages__1iNVA","dateDivider":"Chat_dateDivider__2aWeB"};